import { render, staticRenderFns } from "./ShareOfferTooltip.vue?vue&type=template&id=4a89f7f6&scoped=true&"
import script from "./ShareOfferTooltip.vue?vue&type=script&lang=ts&"
export * from "./ShareOfferTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./ShareOfferTooltip.vue?vue&type=style&index=0&id=4a89f7f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89f7f6",
  null
  
)

export default component.exports